import { io } from "socket.io-client";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const API_ORIGIN = API_BASE_URL.replace(/\/api$/i, "");
const SOCKET_URL = API_ORIGIN;

let socket;

export function connectSocket() {
  if (!socket) {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    socket = io(SOCKET_URL, {
      transports: ["websocket"],
      auth: { token },
    });
    socket.on("connect", () => console.log("✅ Socket connected:", socket.id));
  }
  return socket;
}

export function getSocket() {
  return socket;
}

export function disconnectSocket() {
  if (socket) socket.disconnect();
  socket = null;
}
